import { Table } from "@mantine/core";
import React from "react";

type FormTableLayout = {
  children: React.ReactNode;
  style?: React.CSSProperties;
};
/**
 * Default table layout component.  That way, if we need to change the main table layouts, it's done in one place
 *
 * @param children Must be of type Mantine's <Table.Thead>..,<Table.Tbody>
 * @param style allows you to define/add custom styles
 * @returns
 */
export const FormTableLayout: React.FC<FormTableLayout> = ({
  children,
  ...rest
}) => {
  return (
    <Table
      withRowBorders={false}
      withColumnBorders={false}
      horizontalSpacing="sm"
      verticalSpacing="xs"
      highlightOnHover={false}
      striped={false}
      style={{ tableLayout: "fixed", width: "100%" }}
      {...rest}
      className="print-table"
    >
      {children}
    </Table>
  );
};
